import { createFileRoute } from '@tanstack/react-router'

import { AppShellNoLoginRequired } from '@/components/AppShell'

export const Route = createFileRoute('/_appish')({
  component: AppShellNoLoginRequired,
})
